import React, { createContext, useContext, useMemo } from 'react';
const SelectContext = createContext(undefined);
export const SelectProvider = ({ open, invalid, children }) => {
    const value = useMemo(() => ({
        open,
        invalid,
    }), [open, invalid]);
    return (React.createElement(SelectContext.Provider, { value: value }, children));
};
export const useSelect = () => {
    const context = useContext(SelectContext);
    if (context === undefined) {
        throw new Error('useSelect must be used within a SelectProvider');
    }
    return context;
};
//# sourceMappingURL=SelectContext.js.map